<template>
<div id="app">
    <toolbar v-bind:selection="toolbar" title="Colmenas mini" />


    <div class="content"  style="margin-bottom:60px;">


        <div v-if="!colmenas.length" class="card">
            No hay colmenas mini.<br/><br/>
        </div>

        <div v-else>

            <ul v-for="colmena in colmenas" :key="colmena.id">
                <li class="card" v-bind:id="'mini-'+colmena.id">
                    <div class="info-item">

                        <div class="info-item-list-left">
                            <p class="title-box">{{ colmena.name }}</p>

                            <p>{{ colmena.description }}</p>

                            <p class="vsm-header">ESTADO ACTUAL</p>
                            <p v-if="colmena.states[0]['days']>15" class="text-red">
                                <b>{{colmena.states[0]['days']}} días</b> desde el último estado conocido.
                            </p>
                            <p v-else>
                                <b>{{colmena.states[0]['days']}} días</b> desde el último estado conocido.
                            </p>


                            <p>T{{colmena.states[0]['traslarve']}} -
                            <span v-if="colmena.states[0]['state']==='realera'">Realera</span>
                            <span v-else-if="colmena.states[0]['state']==='virgen'">Reina virgen</span>
                            <span v-else-if="colmena.states[0]['state']==='fecundada'">Reina Fecundada</span>
                            </p>


                            <a @click="showStates(colmena.id)" >

                                <span>

                                <v-icon small>mdi-menu-down-outline</v-icon>

                                </span>
                                VER ESTADOS ({{colmena.states.length}})</a>

                            <div v-bind:id="'states-mini-'+colmena.id" style="display:none">

                                <router-link v-bind:to="'../colmena-mini-estado-nuevo/'+colmena.id" class="btn btn-yellow">
                                    Añadir estado
                                </router-link>

                                <br/><br/>
                                <div v-for="state in colmena.states"

                                     :key="state.id" v-bind:id="'state-'+state.id">



                                    <button v-on:click="deletestate(state.id, colmena.id)">
                                        <v-icon small>delete</v-icon>
                                    </button>


                                    T{{state.traslarve}} / {{state.date.split("-").reverse().join('-')}} /

                                    <span v-if="state.state==='realera'">Realera</span>
                                    <span v-else-if="state.state==='virgen'">Reina virgen</span>
                                    <span v-else-if="state.state==='fecundada'">Reina Fecundada</span>


                                </div>

                            </div>




                        </div>

                        <div class="info-item-list-right">
                            <a v-bind:href="'#/colmena-mini-editar/' + colmena.id">
                                <v-icon small>edit</v-icon>
                            </a>
                            <button v-on:click="deleteMini(colmena.id)">
                                <v-icon small>delete</v-icon>
                            </button>

                        </div>
                    </div>
                </li>
            </ul>

        </div>



    </div>

    <menubottom active="4" />


</div>



</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import menubottom from "@/components/MenuBottom"

import axios from "axios";
export default {

  name: 'colmenas-mini',
  components: {menubottom,toolbar},
    data: () => ({
        toolbar: {
            return: '',
            icons: [
              { text: 'Añadir', href:'colmena-mini-nueva' },
              { text: 'Cancelar', href:'colmenares' }
            ],
          },
        colmenas: null,
        result: null,

  }),



  created() {
  auth.getUserLogged()

    var that = this

        axios.get("https://appws.panimiel.com/new/index.php/api/hive_mini").then((colmenas) => {
          that.colmenas = colmenas.data
        })
  },
   methods:{

       showStates(id){

            if(document.getElementById("states-mini-"+id).style.display === 'none'){
                document.getElementById("states-mini-"+id).style.display = "block";
            }else{
                document.getElementById("states-mini-"+id).style.display = "none";
            }


       },
        deletestate(id, idcolmena){
            var opcion = confirm("¿Seguro que quieres eliminar el estado de la colmena mini?")
            if (opcion == true) {
                axios.delete("https://appws.panimiel.com/new/index.php/api/hive_mini/state/"+id+"/"+idcolmena).then((stateDelete) => {
                    alert(stateDelete.data)
                    document.getElementById("state-"+id).innerHTML=""
                }).catch((error) => {

                    if (error.response.status != 500){
                        alert(error.response.data)
                    }else{
                        alert('Error, no ha sido posible eliminar el estado.')
                    }

                })
             }
        },

        deleteMini(id){


            var opcion = confirm("¿Seguro que quieres eliminar la colmena mini y sus estados?")
            if (opcion == true) {

                axios.delete("https://appws.panimiel.com/new/index.php/api/hive_mini/"+id).then((miniDetele) => {
                    alert(miniDetele.data)
                    document.getElementById("mini-"+id).innerHTML= miniDetele.data
                })
            }



        }


  }


};


</script>

<style scoped lang="scss">
</style>